export const getCategoryFromEvent = ({
  event,
  project,
  availableCategories,
}) => {
  if (project !== 'Manifesto') {
    return 'dedica';
  }
  const eventsMap = {
    Lutto: 'apertura',
    Anniversario: 'dedica',
    Trigesimo: 'dedica',
    Partecipazione: 'dedica',
    Ringraziamento: 'ringraziamento',
  };

  const selectedCategory = eventsMap[event];

  if (selectedCategory) {
    const categoryExist = availableCategories.some(
      (category) => category === selectedCategory
    );
    if (categoryExist) {
      return selectedCategory;
    } else {
      return 'dedica';
    }
  }
  return 'dedica';
};
